"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VulnerableCustomerPaymentHolidayConfirmationPage = exports.VulnerableCustomerPaymentHolidayConfirmationPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var components_1 = require("@athena-portal/components");
var operators_1 = require("rxjs/operators");
var VulnerableCustomerPaymentHolidayPaymentSchedule_1 = require("../../components/VulnerableCustomerPaymentHolidayPaymentSchedule");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var VulnerableCustomerAction_1 = require("../../model/VulnerableCustomerAction");
var commonFunctions_1 = require("../../helpers/commonFunctions");
var VulnerableCustomerPaymentHolidayConfirmationPagePlain = /** @class */ (function (_super) {
    __extends(VulnerableCustomerPaymentHolidayConfirmationPagePlain, _super);
    function VulnerableCustomerPaymentHolidayConfirmationPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.incrementLoadingQueueSize = function (callback) {
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize + 1
            }); }, callback);
        };
        _this.decrementLoadingQueueSize = function (callback) {
            if (_this.state.loadingQueueSize === 0) {
                return;
            }
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize - 1
            }); }, callback);
        };
        _this.toggleInstallmentPlan = function () {
            _this.setState(function (prevState) { return ({
                isOpen: !prevState.isOpen
            }); });
        };
        _this.processPaymentHoliday = function () {
            _this.incrementLoadingQueueSize();
            _this.supportPortalService
                .startVulnerableCustomerAction(_this.props.params.id, _this.props.params.policyNumber, VulnerableCustomerAction_1.VulnerableCustomerActionEnum.PAYMENT_HOLIDAY, _this.props.location.state.actionToConfirmMonths)
                .pipe((0, operators_1.finalize)(function () { return _this.decrementLoadingQueueSize(); }))
                .subscribe(function () {
                _this.storeActionInAdditionalSupportRecord();
                _this.props.navigate("/customers/".concat(_this.props.params.id));
            });
        };
        _this.storeActionInAdditionalSupportRecord = function () {
            var id = _this.props.params.id;
            _this.state.policyActiveAdditionalSupportRecord.appliedAction = VulnerableCustomerAction_1.VulnerableCustomerActionEnum.PAYMENT_HOLIDAY;
            _this.state.policyActiveAdditionalSupportRecord.partyReference = id;
            _this.incrementLoadingQueueSize(function () {
                _this.supportPortalService
                    .updateAdditionalSupportRecord(_this.state.policyActiveAdditionalSupportRecord)
                    .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                    .subscribe();
            });
        };
        _this.state = {
            loadingQueueSize: 0,
            isOpen: false
        };
        _this.cancelChanges = _this.cancelChanges.bind(_this);
        return _this;
    }
    VulnerableCustomerPaymentHolidayConfirmationPagePlain.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.incrementLoadingQueueSize(function () {
                    _this.supportPortalService
                        .previewPaymentHolidaySchedule(_this.props.params.id, _this.props.params.policyNumber, _this.props.location.state.actionToConfirmMonths)
                        .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                        .subscribe({
                        next: function (instalmentsPlanInfo) {
                            _this.setState({ instalmentsPlanInfo: instalmentsPlanInfo });
                        },
                        error: function () {
                            _this.props.navigate("/error?e=Failed to load payment holiday schedule");
                        }
                    });
                });
                this.incrementLoadingQueueSize(function () {
                    _this.supportPortalService
                        .getActiveAdditionalSupportRecord(_this.props.params.policyNumber)
                        .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                        .subscribe(function (record) {
                        _this.setState({
                            policyActiveAdditionalSupportRecord: record
                        });
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    VulnerableCustomerPaymentHolidayConfirmationPagePlain.prototype.render = function () {
        var _a, _b, _c, _d, _e;
        var unpaidInstalments = (_a = this.state.instalmentsPlanInfo) === null || _a === void 0 ? void 0 : _a.unpaidInstalments.length;
        var paidAmount = (_b = this.state.instalmentsPlanInfo) === null || _b === void 0 ? void 0 : _b.paidInstalments.reduce(function (sum, instalment) { return sum + instalment.principal + instalment.interest; }, 0);
        return ((0, jsx_runtime_1.jsxs)("div", { className: "journey-content", children: [(0, jsx_runtime_1.jsx)("h1", { children: "Before You continue..." }), (0, jsx_runtime_1.jsxs)("div", { className: "pt-3 pb-3 mr-5 info-text", children: ["Because you selected a payment holiday of ", this.props.location.state.actionToConfirmMonths, " months, the premiums due will be spread over the remaining ", unpaidInstalments, " instalments. This means the new monthly amount will be ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: (0, commonFunctions_1.getAmountToDisplay)((_c = this.state.instalmentsPlanInfo) === null || _c === void 0 ? void 0 : _c.monthlyPayment) }), ".", (0, jsx_runtime_1.jsx)("p", { children: "Any in flight payments will still be processed." })] }), (0, jsx_runtime_1.jsxs)("div", { className: "mb-3 mt-3", children: [(0, jsx_runtime_1.jsx)("h4", { className: "mb-2 font-weight-bold", children: "Payment Schedule" }), (0, jsx_runtime_1.jsxs)("div", { className: "mb-3", children: ["You have paid ", (0, commonFunctions_1.getAmountToDisplay)(paidAmount), " out of ", (0, commonFunctions_1.getAmountToDisplay)((_d = this.state.instalmentsPlanInfo) === null || _d === void 0 ? void 0 : _d.totalAmount), " (", unpaidInstalments, " instalments left X ", (0, commonFunctions_1.getAmountToDisplay)((_e = this.state.instalmentsPlanInfo) === null || _e === void 0 ? void 0 : _e.monthlyPayment), ")"] }), this.state.instalmentsPlanInfo && (0, jsx_runtime_1.jsx)(VulnerableCustomerPaymentHolidayPaymentSchedule_1.VulnerableCustomerPaymentHolidayPaymentSchedule, { isOpen: this.state.isOpen, instalmentPlanInfo: this.state.instalmentsPlanInfo, paymentHolidayMonths: this.props.location.state.actionToConfirmMonths })] }), (0, jsx_runtime_1.jsx)("div", { children: !this.state.isOpen ?
                        (0, jsx_runtime_1.jsxs)("button", { className: "btn-inner-link btn-text text-center cursor-pointer text-decoration-none mb-5", onClick: this.toggleInstallmentPlan, children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold mx-2", children: "+" }), " ", (0, jsx_runtime_1.jsx)("span", { className: "text-decoration-underline font-weight-bold", children: "View instalments plan" })] })
                        :
                            (0, jsx_runtime_1.jsxs)("button", { className: "btn-inner-link btn-text text-center cursor-pointer text-decoration-none mb-5", onClick: this.toggleInstallmentPlan, children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold mx-2", children: "-" }), " ", (0, jsx_runtime_1.jsx)("span", { className: "text-decoration-underline font-weight-bold", children: "Hide instalments plan" })] }) }), (0, jsx_runtime_1.jsx)("div", { className: "mt-5", children: "Are you happy to proceed with the payment holiday?" }), this.renderNavigationButtons(), this.supportPortalTemplates.renderFooter()] }));
    };
    VulnerableCustomerPaymentHolidayConfirmationPagePlain.prototype.renderNavigationButtons = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-default btn-white-dashboard mr-3", onClick: this.cancelChanges, children: "Cancel" }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-default btn-primary", onClick: this.processPaymentHoliday, children: "Save and confirm" })] }));
    };
    VulnerableCustomerPaymentHolidayConfirmationPagePlain.prototype.cancelChanges = function () {
        this.props.navigate("/customers/".concat(this.props.params.id, "/vulnerableCustomer/paymentHolidays/").concat(this.props.params.policyNumber, "/process"));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], VulnerableCustomerPaymentHolidayConfirmationPagePlain.prototype, "supportPortalService", void 0);
    VulnerableCustomerPaymentHolidayConfirmationPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], VulnerableCustomerPaymentHolidayConfirmationPagePlain);
    return VulnerableCustomerPaymentHolidayConfirmationPagePlain;
}(React.Component));
exports.VulnerableCustomerPaymentHolidayConfirmationPagePlain = VulnerableCustomerPaymentHolidayConfirmationPagePlain;
exports.VulnerableCustomerPaymentHolidayConfirmationPage = (0, components_1.withRouter)(VulnerableCustomerPaymentHolidayConfirmationPagePlain);
//# sourceMappingURL=VulnerableCustomerPaymentHolidayConfirmationPage.js.map